import { useRef, useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import './CategoryCarousel.css';

const defaultCategories = [
  {
    id: 1,
    image: '/imagenes/fiestas-y-festivales.webp',
    subtitle: 'Festivales',
    title: 'FIESTAS &\nFESTIVALES',
    buttonText: 'Ver más',
    link: '/categoria/festivales'
  },
  {
    id: 2,
    image: '/imagenes/standup-comedy.webp',
    subtitle: 'Comedia',
    title: 'STAND UP\nCOMEDY',
    buttonText: 'Ver más',
    link: '/categoria/comedia'
  },
  {
    id: 3,
    image: '/imagenes/obras-teatrales.webp',
    subtitle: 'Teatro',
    title: 'OBRAS\nTEATRALES',
    buttonText: 'Ver más',
    link: '/categoria/teatro'
  },
  {
    id: 4,
    image: '/imagenes/Cali.webp',
    subtitle: '',
    title: '',
    buttonText: 'Punto de Venta',
    link: '/puntos-de-venta'
  }
];

export default function CategoryCarousel() {
  const trackRef = useRef(null);
  const { data: carouselData } = useQuery({
    queryKey: ['heroCarousel'],
    queryFn: async () => {
      const res = await fetch('/api/homepage').then(r => r.json());
      if (res.exito && res.datos.carousel?.length > 0) {
        return res.datos.carousel.map((c, i) => ({
          id: i + 1,
          image: c.image_url,
          subtitle: '',
          title: c.title || '',
          buttonText: 'Ver mas',
          link: c.link || '#',
        }));
      }
      return null;
    },
    staleTime: 60 * 1000,
    placeholderData: () => {
      const d = window.__HOMEPAGE_DATA__;
      if (d?.exito && d.datos?.carousel?.length > 0) {
        return d.datos.carousel.map((c, i) => ({
          id: i + 1, image: c.image_url, subtitle: '',
          title: c.title || '', buttonText: 'Ver mas', link: c.link || '#',
        }));
      }
      return undefined;
    },
  });

  const categories = carouselData || defaultCategories;
  const [replicas, setReplicas] = useState(2);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = trackRef.current;
    // Si estamos a menos de 500px del borde derecho, agregar otra réplica
    if (scrollWidth - (scrollLeft + clientWidth) < 500) {
      setReplicas(r => r + 1);
    }
  };

  const scrollLeftBtn = () => {
    if (trackRef.current) {
      trackRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRightBtn = () => {
    if (trackRef.current) {
      trackRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  // Reproducción automática cada 7 segundos solo en pantallas menores a 1024px (donde se muestran las flechas)
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.innerWidth <= 1024) {
        scrollRightBtn();
      }
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  // Construir el arreglo de categorías combinando réplicas
  const displayCategories = Array(replicas).fill(categories).flat();

  return (
    <section className="category-carousel-section">
      <h2 className="category-carousel-title">MÁS EVENTOS</h2>
      <div className="category-carousel-container">
        <button className="carousel-nav-btn prev" aria-label="Previous" onClick={scrollLeftBtn}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="category-carousel-track" ref={trackRef} onScroll={handleScroll}>
          {displayCategories.map((category, index) => (
            <div key={`${category.id}-${index}`} className="category-card">
              <img src={category.image} alt={category.title || category.buttonText} className="category-card-bg" width="350" height="480" loading={index < 4 ? 'eager' : 'lazy'} fetchPriority={index === 0 ? 'high' : 'auto'} />
              <div className="category-card-content">
                <div className="category-card-text">
                  {category.subtitle && <span className="category-subtitle">{category.subtitle}</span>}
                  {category.title && <h3 className="category-title">{category.title}</h3>}
                </div>
                <a href={category.link} className="category-btn">
                  {category.buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-nav-btn next" aria-label="Next" onClick={scrollRightBtn}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </section>
  );
}
